import axios from '../../plugins/TradutorInterceptor'

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    listaTarifasConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tarifas/' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listarGruposTarifarios(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('grupos-tarifarios' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    criarTarifasConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('tarifas', payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    atualizarTarifasConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('tarifas', payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    excluirTarifasConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('tarifas/' + payload.concessionaria_id + '/' + payload.ano_tarifario)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listarTarifasPorAno(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tarifas/' + payload.concessionaria_id + '/' + payload.ano_tarifario)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/tarifasConcessionaria.js